import { useState } from "react";
import AuthCard from "../../components/auth/AuthCard";
import LoginForm from "../../components/auth/LoginForm";
import { useNavigate, useSearchParams } from "react-router-dom";
import main from "../../assets/images/main.png";

export default function Login() {
    const STEP = { SELECT: "select", FORM: "form" };
    const [params, setParams] = useSearchParams();
    const go = (next) => next ? setParams({ step: next }) : setParams();
    const step = params.get("step") || STEP.SELECT;
    const nav = useNavigate();

    return (
        <main className="h-[var(--app-height)] flex items-center justify-center px-7 font-suit">
            <AuthCard
                title="로그인"
                {...(step === STEP.SELECT ? {} : { onClose: () => nav(-1) })}
                className="h-full w-full "
            >
                {step === STEP.SELECT && (
                    <>
                        <div className="py-9">
                            <p className="text-2xl md:text-3xl  leading-tight">
                                운동 기록과 처방을 하나로<br />
                                <span className="font-bold">스마트 피트니스</span>
                            </p>
                            <p className="text-sm md:text-lg text-[#4A8AFF] mt-2">
                                로그인하거나 회원가입을 진행해 주세요.
                            </p>
                        </div>
                        <div className="flex-1 flex justify-center items-center my-4">
                            <img
                                src={main}
                                className="w-full max-w-[370px] md:max-w-[420px] object-contain"
                                alt="메인이미지"
                            />
                        </div>

                        <div className="mt-auto  py-6 space-y-3 " >
                            <button
                                onClick={() => nav("/signup")}
                                className="
                            w-full
                            bg-[#5F9BFF]         
                            text-white
                            py-3
                            border-[1px]        
                            border-[#5F9BFF]
                            md:py-4 
                            rounded-xl
                            text-lg 
                            md:text-xl
                            "
                            >회원가입</button>
                            <button
                                onClick={() => go(STEP.FORM)}
                                className="
                            w-full
                            border-solid          
                            border-[1px]        
                            border-[#5F9BFF]
                            text-[#5F9BFF]
                            py-3 
                            md:py-4 
                            rounded-xl
                            text-lg 
                            md:text-xl
                        "
                            >
                                회원 로그인
                            </button>

                        </div>
                    </>
                )}

                {/* 로그인 진행 폼 */}
                {step === STEP.FORM && (
                    <LoginForm onBack={() => go()} />
                )}
            </AuthCard>
        </main >
    );
}
